<template>
  <section class="wcv">
    <span class="wcv__icon">
      <v-icon icon="mdi-swap-horizontal" size="16" />
    </span>
    <span class="wcv__text">
      <span class="wcv__eyebrow">Ihre Zahnzusatzversicherung</span>
      <span class="wcv__title">
        {{ tarif.un_name }} {{ tarif.tarif_title }}
      </span>
    </span>
    <a
      class="wcv__cta"
      @click="berechnungStore.setShowPop(tarif, 'dreivergleich')"
    >
      <v-icon icon="mdi-compare-horizontal" size="14" />
      Im Vergleich öffnen
      <v-icon icon="mdi-arrow-right" size="13" class="wcv__arr" />
    </a>
  </section>
</template>

<script setup>
  import { defineProps } from "vue";
  import { useBerechnungStore } from "@/stores/berechnung";
  const berechnungStore = useBerechnungStore();

  defineProps({
    tarif: { type: Object, default: () => ({}) },
    berechnung: { type: Object, default: () => ({}) },
  });
</script>

<style scoped>
  .wcv {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #f7f9fc;
    border: 1px solid #e5e9f0;
    border-left: 3px solid #0f4c81;
    border-radius: 3px;
    padding: 10px 14px;
    margin: 8px 0 12px;
  }
  .wcv__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    background: #0f4c81;
    color: #fff;
    border-radius: 3px;
    flex-shrink: 0;
  }
  .wcv__text {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;
  }
  .wcv__eyebrow {
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: #5b6473;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
      monospace;
  }
  .wcv__title {
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.25;
  }
  .wcv__cta {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #ffffff;
    color: #0f4c81;
    border: 1px solid #cfdde9;
    border-radius: 3px;
    padding: 6px 10px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;
    transition: background-color 0.12s ease, border-color 0.12s ease;
    white-space: nowrap;
  }
  .wcv__cta:hover {
    background: #f0f5fa;
    border-color: #b6cce0;
  }
  .wcv__arr {
    margin-left: 2px;
  }
  @media (max-width: 560px) {
    .wcv {
      flex-wrap: wrap;
      gap: 8px;
    }
    .wcv__cta {
      width: 100%;
      justify-content: center;
    }
  }
</style>
